import { defineNuxtPlugin } from 'nuxt/app'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

export default defineNuxtPlugin((nuxtApp) => {
  if (!process.client) return
  nuxtApp.vueApp.use(VueToast, {
    duration: 5000
  })
})
